import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import * as globals from './components/GlobalScripts.js';
import './styles/GlobalStyles.css';
import ScrollToTop from './pages/ScrollToTop';
import Admin from './pages/Admin';
import Admin_home from './pages/admin/Admin_home';
import Admin_pedidos from './pages/admin/Admin_pedidos';
import Admin_pedido_ver from './pages/admin/Admin_pedido_ver';
import Admin_pagos from './pages/admin/Admin_pagos';
import Admin_pagos_ver from './pages/admin/Admin_pagos_ver';
import Admin_clientes from './pages/admin/Admin_clientes';
import Admin_clientes_edit from './pages/admin/Admin_clientes_edit';
import Admin_referidos from './pages/admin/Admin_referidos';
import Admin_reportes from './pages/admin/Admin_reportes';
import Admin_cuenta from './pages/admin/Admin_cuenta';
import Admin_direccion from './pages/admin/Admin_direccion';
import Admin_platillos from './pages/admin/Admin_platillos';
import AdminPlatilloEditor from './pages/admin//AdminPlatilloEditor.jsx';
import Admin_menu_semanal from './pages/admin/Admin_menu_semanal';
import Admin_cupones from './pages/admin/Admin_cupones';

import Cliente from './pages/Cliente';
import Cliente_home from './pages/cliente/Cliente_home';
import Cliente_menu_pedidos from './pages/cliente/Cliente_menu_pedidos';
import Cliente_menu_pedidos_wizard from './pages/cliente/Cliente_menu_pedidos_wizard';
import Cliente_pedidos from './pages/cliente/Cliente_pedidos';
import Cliente_pedidos_calificar from './pages/cliente/Cliente_pedidos_calificar';
import Cliente_pagos from './pages/cliente/Cliente_pagos';
import Cliente_pagos_ver from './pages/cliente/Cliente_pagos_ver';
import Cliente_referidos from './pages/cliente/Cliente_referidos';
import Cliente_cuenta from './pages/cliente/Cliente_cuenta';
import Cliente_direccion from './pages/cliente/Cliente_direccion';
import Cliente_renovacion from './pages/cliente/Cliente_renovacion.jsx';
import Login from './pages/Login';
import Registrate from './pages/Registrate';
import TerminosCondiciones from './pages/TerminosCondiciones';
import ErrorBoundary from './components/ErrorBoundary';

const PrivateRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  return globals.isAuthenticated() && user?.rol == 4 ? children : <Navigate to="/login" replace />;
};

const PrivateRouteClient = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  return globals.isAuthenticated() && user?.rol == 1 ? children : <Navigate to="/login" replace />;
};

const HomeRedirect = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (!globals.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (user?.rol == 1) {
    return <Navigate to="/cliente/dashboard" replace />;
  } else if (user?.rol == 4) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
};

function App() {
  localStorage.setItem('path_api', 'https://twonutris.net/backend');

  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            path="/admin/*"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          >
            <Route path="dashboard" element={<Admin_home />} />
            <Route path="pedidos" element={<Admin_pedidos />} />
            <Route path="pedido/ver" element={<Admin_pedido_ver />} />
            <Route path="pagos" element={<Admin_pagos />} />
            <Route path="pagos/:id" element={<Admin_pagos_ver />} />
            <Route path="clientes" element={<Admin_clientes />} />
            <Route path="clientes/:id" element={<Admin_clientes_edit />} />
            <Route path="referidos" element={<Admin_referidos />} />
            <Route path="reportes" element={<Admin_reportes />} />
            <Route path="cuenta" element={<Admin_cuenta />} />
            <Route path="direccion" element={<Admin_direccion />} />
            <Route path="platillos" element={<Admin_platillos />} />
            <Route path="platillos/nuevo" element={<AdminPlatilloEditor />} />
            <Route path="platillos/:id/editar" element={<AdminPlatilloEditor />} />
            <Route path="platillos/:id/clonar" element={<AdminPlatilloEditor />} />
            <Route path="menus" element={<Admin_menu_semanal />} />
            <Route path="cupones" element={<Admin_cupones />} />
          </Route>
          <Route
            path="/cliente/*"
            element={
              <PrivateRouteClient>
                <Cliente />
              </PrivateRouteClient>
            }
          >
            <Route path="dashboard" element={<Cliente_home />} />
            <Route path="menu" element={<Cliente_menu_pedidos />} />
            <Route path="menu/:dayKey/:type" element={<Cliente_menu_pedidos_wizard />} />
            <Route path="menu/ver" element={<Cliente_menu_pedidos />} />
            <Route path="pedidos" element={<Cliente_pedidos />} />
            <Route path="pedidos/calificar" element={<Cliente_pedidos_calificar />} />
            <Route path="pagos" element={<Cliente_pagos />} />
            <Route path="pagos/:id" element={<Cliente_pagos_ver />} />
            <Route path="referidos" element={<Cliente_referidos />} />
            <Route path="cuenta" element={<Cliente_cuenta />} />
            <Route path="direccion" element={<Cliente_direccion />} />
            <Route path="renovacion" element={<Cliente_renovacion />} />
          </Route>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrate" element={<Registrate />} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
